import { render, staticRenderFns } from "./TabHeaderSectionLayout.vue?vue&type=template&id=0d155492&scoped=true&"
import script from "./TabHeaderSectionLayout.vue?vue&type=script&lang=js&"
export * from "./TabHeaderSectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d155492",
  null
  
)

export default component.exports